export default "__VITE_ASSET__c6Hhm7LS__"